import { createContext, MutableRefObject, useContext } from 'react';

export interface IActiveElement {
  id: string;
  target: HTMLElement;
}

interface IPreviewContext {
  portalRef: MutableRefObject<HTMLDivElement>['current'];
  activeElement: IActiveElement;
  setActiveElement: (element: IActiveElement) => void;
  cancelTimeout: () => void;
}

const PreviewContext = createContext<IPreviewContext>({
  portalRef: null,
  activeElement: {
    id: null,
    target: null,
  },
  setActiveElement: null,
  cancelTimeout: null,
});

export const usePreviewContext = () => {
  const context = useContext(PreviewContext);
  return context;
};

export default PreviewContext;
